
// import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
//plugins
import NowUIKit from './plugins/now-ui-kit';
// import VueParticles from 'vue-particles'
// import VueAnalytics from 'vue-analytics'
// const VueAnalytics = require('vue-analytics').default

Vue.config.productionTip = false;
Vue.use(NowUIKit);
// Vue.use(VueAnalytics, {
//   id: 'UA-89795959-13',
//   disableScriptLoader: true,
//   router
// })
// Vue.use(VueParticles)
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

// var deferredPrompt;

// window.addEventListener('beforeinstallprompt', (e) => {
//   console.log('event')
//   // Prevent Chrome 67 and earlier from automatically showing the prompt
//   e.preventDefault();
//   // Stash the event so it can be triggered later.
//   deferredPrompt = e;
//   deferredPrompt.prompt();
//   // Wait for the user to respond to the prompt
//   deferredPrompt.userChoice
//     .then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('User accepted the A2HS prompt');
//       } else {
//         console.log('User dismissed the A2HS prompt');
//       }
//       deferredPrompt = null;
//     });
//   // Update UI notify the user they can add to home screen
//   // btnAdd.style.display = 'block';
// });

// btnAdd.addEventListener('click', (e) => {
//   // hide our user interface that shows our A2HS button
//   btnAdd.style.display = 'none';
//   // Show the prompt
//   deferredPrompt.prompt();
//   // Wait for the user to respond to the prompt
//   deferredPrompt.userChoice
//     .then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('User accepted the A2HS prompt');
//       } else {
//         console.log('User dismissed the A2HS prompt');
//       }
//       deferredPrompt = null;
//     });
// });